/* eslint-disable no-undef */
(function (window) {
    "use strict";
    function defineCustomerService() {
        let customerService = {};
        customerService.getCompanies = function (request) {
            return axios.post("/api/CustomerService/GetCompanies", request);
        };
        customerService.getCompanyBillingAddresses = function (request) {
            return axios.post("/api/CustomerService/GetCompanyBillingAddresses", request);
        };
        customerService.getCompanyShippingAddresses = function (request) {
            return axios.post("/api/CustomerService/GetCompanyShippingAddresses", request);
        };
        customerService.getCompanyAddress = function (companyAddressId) {
            return axios.get("/api/CustomerService/GetCompanyAddress?companyAddressId=" + companyAddressId);
        };
        customerService.getCompanyVehicles = function (request) {
            return axios.post("/api/CustomerService/GetCompanyVehicles", request);
        };
        customerService.getPeopleToNotifyByCompanyVehicle = function (request) {
            return axios.post("/api/CustomerService/GetPeopleToNotifyByCompanyVehicle", request);
        };
        customerService.addOrUpdateCompany = function (request) {
            return axios.post("/api/CustomerService/AddOrUpdateCompany", request);
        };
        customerService.addOrUpdateCustomerBillingAddress = function (request) {
            return axios.post("/api/CustomerService/AddOrUpdateCustomerBillingAddress", request);
        };
        customerService.addOrUpdateCustomerShippingAddress = function (request) {
            return axios.post("/api/CustomerService/AddOrUpdateCustomerShippingAddress", request);
        };
        customerService.addOrUpdatePersonToNotifyForVehicle = function (request) {
            return axios.post("/api/CustomerService/AddOrUpdatePersonToNotifyForVehicle", request);
        };
        customerService.addOrUpdateCustomerVehicle = function (request) {
            return axios.post("/api/CustomerService/AddOrUpdateCustomerVehicle", request);
        };
        customerService.loadCustomerCredits = function (request) {
            return axios.post("/api/CustomerService/LoadCustomerCredits", request);
        };
        customerService.reduceCustomerCredits = function (request) {
            return axios.post("/api/CustomerService/ReduceCustomerCredits", request);
        };
        customerService.markCompanyAsActiveOrInactive = function (request) {
            return axios.post("/api/CustomerService/MarkCompanyAsActiveOrInactive", request);
        };
        customerService.markVehicleAsActiveOrInactive = function (request) {
            return axios.post("/api/CustomerService/MarkVehicleAsActiveOrInactive", request);
        };
        customerService.markPersonToNotifyAsActiveOrInactive = function (request) {
            return axios.post("/api/CustomerService/MarkPersonToNotifyAsActiveOrInactive", request);
        };
        customerService.markCompanyAddressAsActiveOrInactive = function (request) {
            return axios.post("/api/CustomerService/MarkCompanyAddressAsActiveOrInactive", request);
        };
        customerService.getCompany = function (request) {
            return axios.post("/api/CustomerService/GetCompany", request);
        };
        customerService.getPersonToNotifyRoles = function () {
            return axios.get("/api/CustomerService/GetPersonToNotifyRoles");
        };
        customerService.getCompanyVehicle = function (request) {
            return axios.post("/api/CustomerService/GetCompanyVehicle", request);
        };
        customerService.getCompanyVehiclesAssignedToUser = function (request) {
            return axios.post("/api/CustomerService/GetCompanyVehiclesAssignedToUser", request);
        };
        customerService.addVehicleUsers = function (request) {
            return axios.post("/api/CustomerService/AddVehicleUsers", request);
        };
        customerService.assignAndUnassignVehiclesFromCustomerUsers = function (request) {
            return axios.post("/api/CustomerService/AssignAndUnassignVehiclesFromCustomerUsers", request);
        };
        customerService.getZonesLinkedAndUnlinkedToCompany = function (companyId) {
            return axios.get("/api/CustomerService/GetZonesLinkedAndUnlinkedToCompany?companyId=" + companyId);
        };
        customerService.suspendCompany = function (request) {
            return axios.post("/api/CustomerService/SuspendCompany", request);
        };
        customerService.reinstateSuspendedCompany = function (request) {
            return axios.post("/api/CustomerService/ReinstateSuspendedCompany", request);
        };
        customerService.downloadCustomersWithOverduePaymentsReport = function (request){
            return axios.post("/api/CustomerService/DownloadCustomersWithOverduePaymentsReport", request, { responseType: 'blob' });
        };
        return customerService;
    }
    //define globally if it doesn't already exist
    if (typeof (customerService) === "undefined") {
        window.customerService = defineCustomerService();
    } else {
        console.log("customerService already defined.");
    }
})(window);